import axios from 'axios';
import XMLSchema from 'xml-schema';

import { bgg, gallery } from '../config';
import { SearchResultSchema, BoardgameDetailSchema } from '../xmlSchema';

class BggService {

  static async search(q, type = 'boardgame') {
    return axios
      .get(`${bgg.url}/search?query=${q}&type=${type}`)
      .then(response => (new XMLSchema(SearchResultSchema)).parse(response.data));
  }

  static async get(id, type = 'boardgame') {
    return axios
      .get(`${bgg.url}/thing?id=${id}&type=${type}`)
      .then(response => (new XMLSchema(BoardgameDetailSchema)).parse(response.data));
  }

  static async getGalleryForId(id, page = 1, limit = 24) {
    return axios
      .get(`${gallery.url}/boardgames/${id}/gallery?page=${page}&limit=${limit}`, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          'X-Api-Key': gallery.apiKey,
        },
      })
      .then(response => response.data);
  }
}

export default BggService;